import React from 'react';
import Row from '../../../../shared/components/Row';
import Card from '../../../../shared/components/Card';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../../shared/components/CardBody';
import WorksRequest from '../../../../works/ws/WorksRequest';
import Paginator from '../../../../shared/components/Paginator';
import { WorkListTable } from './WorkListTable';
import { PsWork } from '../PsWork';

export class WorkListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: '',
            loading: false,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
        };
    }

    componentDidMount() {
        this.listConstructionSites();
    }

    render() {
        const {
            data,
            error,
            search,
            loading,
            pagination,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_SELECCION_OBRA').toUpperCase()}
                        subtitle={I18nUtils.tr('TR_OBRAS_ACTIVAS')}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={false}
                                searchText={search}
                                onRefresh={this.refresh}
                                onSearch={this.search}
                            />
                        )}
                    />
                    <CardBody>
                        <WorkListTable
                            data={data}
                            error={error}
                        />
                        <Paginator
                            data={pagination}
                            onPage={this.selectPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    refresh = () => {
        this.listConstructionSites();
    };

    search = (search) => {
        this.setState({ search, page: 1 }, this.listConstructionSites);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listConstructionSites);
    };

    listConstructionSites = () => {
        const { page, search } = this.state;

        new WorksRequest(page, search)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess(res => {
                const data = PsWork.arrayFromBackend(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

}

WorkListCard.propTypes = {};

WorkListCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/work/WorkListCard.jsx